
import { css } from 'lit';
export default css`
:host{
  display:block;
  --wysiwyg-font-color:var(--neutral-medium-gray);
}

.story-block{
  display:grid;
  row-gap:var(--spacing-6);
}

@media (min-width: 992px){

.story-block{
    column-gap:10%;
    grid-template-columns:1fr 1fr
}
  }

.column-left{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

@media (min-width: 992px){

.column-left{
    gap:var(--spacing-8)
}
  }

.column-right{
  border-top:2px solid var(--purple-medium-neutral);
}

@media (min-width: 992px){

.image{
    margin-top:var(--spacing-8)
}
  }
`;